import { TextField } from "@mui/material";
import { useCallback } from "react";
import { ModelSavingData } from "src/hooks/use-model-saving-data";

export type TruxTextFieldProps<T> = {
  modelSavingData: ModelSavingData<T>,
  field: keyof T,
  label?: string,
  onChange?: (t: T) => boolean | void,
  multiline?: boolean,
  minRows?: number,
  disabled?: boolean,
  type?: string,
}

export default function TruxTextField<T>({ modelSavingData, field, onChange, label, multiline, minRows, disabled = false, type }: TruxTextFieldProps<T>) {
  const fieldOnChange = useCallback((e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const val = e.target.value as any;

    const prev = modelSavingData.model?.[field] as any;
    modelSavingData.update(data => {
      data[field] = val
      modelSavingData.model![field] = val;

      if (onChange && onChange(data)) {
        data[field] = prev;
      }
    });

  }, [modelSavingData, field, onChange]);

  const currentValue = modelSavingData.model?.[field as keyof T];

  return <TextField type={type} disabled={disabled} multiline={multiline} minRows={minRows} autoComplete="off" size="small" label={label} sx={{ display: "flex", width: "100%" }} value={currentValue} onChange={fieldOnChange} />
}